export default __webpack_public_path__ + "static/media/about1.1bd22224.png";